// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lqav3","tabsBox":"styles_tabsBox__1eX7P","createButton":"styles_createButton__fJV8p"};